// extracted by mini-css-extract-plugin
module.exports = {"App":"App_App__2dbOb","logo":"App_logo__26Log","imprintLink":"App_imprintLink__blIPf"};